'use strict';

var TileHeaderView = Marionette.ItemView.extend({
    template: require('components/dashboard/templates/tile_header'),
    className: 'tile-header',

    ui: {
        fullscreen: '.js-fullscreen',
    },

    triggers: {
        'click @ui.fullscreen': 'toggleFullscreen',
    },

    serializeData: function () {
        return this.options;
    },
});

module.exports = TileHeaderView;
